export enum InitializerKey {
  Cipher = 0,
  CipherView = 1,
}
